import React, { memo, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { _formatDate3 } from 'utils';
import { numberFormat } from 'utils';
import { formatDate } from 'utils';
import { log } from 'utils';

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

var emphasisStyle = {
  itemStyle: {
    shadowBlur: 10,
    shadowColor: 'rgba(0,0,0,0.3)',
  },
};

function ChartStockNetBuy(props) {
  const abortController = new AbortController();
  // ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc']
  const DEFAULT_OPTION = {
    grid: { top: 8, right: 45, bottom: 20, left: 15 },
    color: ['#13BA7F', '#F5465C'],
    legend: {
      show: false,
      data: ['bar', 'bar2'],
      left: '10%',
    },
    xAxis: {
      //   type: 'category',
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
        length: 3,
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        // formatter: function (value, index) {
        //   const arr = value.split(':');
        //   return arr[0] + ':' + arr[1];
        // },
        borderColor: '#ECECEC',
        showMinLabel: true,
        showMaxLabel: true,
      },
      data: [],
      // show: false,
      axisLine: { onZero: true },
      splitLine: { show: false },
      splitArea: { show: false },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'right',
      alignTicks: true,
      splitNumber: 6,
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        formatter: val => `${Math.abs(val) >= 1000000 ? val/ 1000000 : val/ 1000}${Math.abs(val) >= 1000000 ? 'M' : 'K'}`,
        color: '#83817C',
        fontSize: 8,
        showMinLabel: false,
        margin: 15,
      },
    },
    series: [
      {
        name: '',
        type: 'bar',
        stack: 'one',
        emphasis: emphasisStyle,
        itemStyle: {
          color: '#13BA7F',
        },
        data: [],
      },
      // {
      //   name: 'Bán ròng',
      //   type: 'bar',
      //   stack: 'one',
      //   emphasis: emphasisStyle,
      //   itemStyle: {
      //     color: '#F5465C',
      //   },
      //   data: [],
      // },
    ],
    tooltip: {
      // show: false,
      trigger: 'item',
      // formatter: '{a} <br/>{b}: {c}',
      formatter: function (value, index) {
        // console.log(value)
        return `${value.value > 0 ? 'Mua ròng' : 'Bán ròng'} : ${numberFormat(
          Math.abs(value.value)
        )}`;
      },
    },
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { symActive } = props;

  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if (symActive) _handleLoadDataStock();
  }, [symActive]);

  function _handleLoadDataStock() {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    const _endDate = formatDate(new Date(), '-');
    const _startDate = formatDate(d, '-');

    const params = {
      lang: 'vi',
      secCode: symActive,
      startDate: _startDate,
      endDate: _endDate,
    };

    fetch(appUrl + 'pbapi/api/secTradingHistory', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(params),
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        _mapDataToState(JSON.parse(res.data).reverse());
      })
      .catch((error) => {
        log(error);
      });
  }

  function _mapDataToState(dt) {
    const newOption = _.cloneDeep(option);
    let xAxisData = [];
    let data1 = [];

    log(dt);

    for (let index = 0; index < dt.length; index++) {
      if (index > 9) continue;

      const element = dt[index];
      xAxisData.push(_formatDate3(element.TRADE_DATE));
      // data1.push(element.F_NET_BUY_VOLUME);

      data1.push({
        // name: element.F_NET_BUY_VOLUME > 0 ? 'Mua ròng' : 'Bán ròng',
        value: element.F_NET_BUY_VOLUME,
        itemStyle: {
          color: element.F_NET_BUY_VOLUME > 0 ? '#13BA7F' : '#F5465C',
        },
      });
    }

    // console.log(dt)

    newOption.xAxis.data = xAxisData.reverse();

    newOption.series[0].data = data1.reverse();
    // newOption.series.data[0].children = data1;

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100px',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartStockNetBuy);
